<div class="toggle-div">
    <ds-switch
        [class]="isDisabled ? 'density-switch-disable-gray' : ''"
        [name]="name"
        [(ngModel)]="value"
        (ngModelChange)="toggleChange.emit(value)"
        [disabled]="isDisabled">
    </ds-switch>
    <p [class]="pClass ? 'sera-toggle ' + pClass : 'sera-toggle'">
        {{ label }}
    </p>
</div>
